import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';
import { useNavigate } from 'react-router-dom';

function useChangeExpiredPassword() {
  const navigate = useNavigate();
  const { state } = useProvider();
  const args = state;

  return useMutation<any, ApiError, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      await api.post({
        url: 'api/v2/auth/accounts/change-password',
        payload,
      });
    },
    onSuccess: () => {
      toastSuccess('Successfully updated password');

      navigate('/logout');
    },
  });
}

export default useChangeExpiredPassword;
